// src/components/HR/HRDashboard.jsx - CON TAB VERIFICA PERSONALE
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, doc, updateDoc, limit } from 'firebase/firestore';
import { db } from '../../firebase';

// Import componenti Admin (riutilizzati)
import AdminWorkHours from '../Admin/AdminWorkHours';
import IncarichiManagement from '../Admin/IncarichiManagement';
import AdminReportsTable from '../Admin/AdminReportsTable';
import AdminLeaveRequests from '../Admin/AdminLeaveRequests';
import AdminQRManagement from '../Admin/AdminQRManagement';
import AdminReports from '../Admin/AdminReports';
import AdminFilters from '../Admin/AdminFilters';

// ✅ NUOVO: Import wrapper VerificaPersonale per HR
import HRVerificaPersonale from './HRVerificaPersonale';

import './hr.css';

const HRDashboard = () => {
  const [activeTab, setActiveTab] = useState('hours');

  // ==============================
  // STATI PER SEGNALAZIONI
  // ==============================
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [loadingReports, setLoadingReports] = useState(false);
  
  // Stati per i filtri
  const [filters, setFilters] = useState({
    month: '',
    year: '',
    status: '',
    user: ''
  });

  // AGGIUNGI SUBITO DOPO:
const [showAllReports, setShowAllReports] = useState(false);
const [totalReportsCount, setTotalReportsCount] = useState(0);

  // ==============================
  // CARICAMENTO SEGNALAZIONI
  // ==============================
  useEffect(() => {
    if (activeTab === 'reports') {
      loadReports();
    }
  }, [activeTab, showAllReports]); // ✅ Aggiungi showAllReports

  const loadReports = async () => {
    try {
      setLoadingReports(true);
      
      // Prima: conta il totale
      const countQuery = query(collection(db, 'reports'));
      const countSnapshot = await getDocs(countQuery);
      const totalCount = countSnapshot.size;
      setTotalReportsCount(totalCount);
      
      // Poi: carica con o senza limite
      const reportsRef = collection(db, 'reports');
      let reportsQuery;
      
      if (showAllReports) {
        // Carica tutte
        reportsQuery = query(reportsRef, orderBy('createdAt', 'desc'));
        console.log('HR Dashboard: Caricamento di TUTTE le segnalazioni');
      } else {
        // Carica solo ultime 10
        reportsQuery = query(
          reportsRef, 
          orderBy('createdAt', 'desc'),
          limit(10)
        );
        console.log('HR Dashboard: Caricamento delle ultime 10 segnalazioni');
      }
      
      const querySnapshot = await getDocs(reportsQuery);
      const reportsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      console.log(`HR Dashboard: Caricate ${reportsData.length} segnalazioni (totale: ${totalCount})`);
      setReports(reportsData);
      setFilteredReports(reportsData);
    } catch (error) {
      console.error('Errore nel caricamento delle segnalazioni:', error);
    } finally {
      setLoadingReports(false);
    }
  };

  // ==============================
  // APPLICAZIONE FILTRI
  // ==============================
  useEffect(() => {
    // Se un filtro è attivo e non abbiamo caricato tutto, carica tutto
    const hasActiveFilters = 
      filters.month !== '' || 
      filters.year !== '' || 
      filters.status !== '' || 
      filters.user !== '';
    
    if (hasActiveFilters && !showAllReports) {
      console.log('HR Dashboard: Filtri attivi, caricamento di tutte le segnalazioni...');
      setShowAllReports(true);
      return;
    }
    
    // Applica i filtri
    let filtered = [...reports];
    
    // Filtra per mese
    if (filters.month) {
      filtered = filtered.filter(report => {
        const reportDate = report.createdAt?.toDate?.() || new Date(report.createdAt);
        const reportMonth = reportDate.getMonth() + 1;
        return reportMonth === parseInt(filters.month);
      });
    }
    
    // Filtra per anno
    if (filters.year) {
      filtered = filtered.filter(report => {
        const reportDate = report.createdAt?.toDate?.() || new Date(report.createdAt);
        const reportYear = reportDate.getFullYear();
        return reportYear === parseInt(filters.year);
      });
    }
    
    // Filtra per stato
    if (filters.status) {
      filtered = filtered.filter(report => report.status === filters.status);
    }
    
    // Filtra per utente
    if (filters.user) {
      filtered = filtered.filter(report => report.userEmail === filters.user);
    }
    
    console.log(`HR Dashboard: Filtri applicati, ${filtered.length} risultati da ${reports.length} totali`);
    setFilteredReports(filtered);
  }, [filters, reports, showAllReports]);

  // ==============================
  // GESTIONE AGGIORNAMENTO STATO
  // ==============================
  const handleStatusChange = async (reportId, newStatus, notes) => {
    try {
      const reportRef = doc(db, 'reports', reportId);
      const updateData = {
        status: newStatus,
        lastUpdate: new Date()
      };
      
      if (notes) {
        updateData.adminNotes = notes;
        updateData.adminNotesDate = new Date();
      }
      
      await updateDoc(reportRef, updateData);
      
      console.log('HR Dashboard: Stato aggiornato per report', reportId);
      
      // Ricarica le segnalazioni
      await loadReports();
    } catch (error) {
      console.error('Errore nell\'aggiornamento dello stato:', error);
    }
  };

  // ==============================
  // RENDERING CONTENUTO TAB
  // ==============================
  const renderTabContent = () => {
    switch (activeTab) {
      case 'hours':
        return <AdminWorkHours />;
      
      case 'users':
        return <IncarichiManagement />;
      
        case 'reports':
          return (
            <div>
              <AdminFilters
                filters={filters}
                setFilters={setFilters}
                reports={reports}
              />
              
              {/* Banner info + bottone carica tutte */}
              {!showAllReports && totalReportsCount > 10 && (
                <div style={{
                  background: '#e8f5e9',
                  padding: '12px 20px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  border: '1px solid #81c784'
                }}>
                  <div style={{ color: '#2e7d32', fontSize: '14px' }}>
                    📊 Visualizzate le ultime <strong>10 segnalazioni</strong> su <strong>{totalReportsCount} totali</strong>
                  </div>
                  <button
                    onClick={() => setShowAllReports(true)}
                    style={{
                      background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
                      color: 'white',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: '600',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    📋 Carica tutte le segnalazioni
                  </button>
                </div>
              )}
              
              {loadingReports ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div className="spinner"></div>
                  <p>Caricamento segnalazioni...</p>
                </div>
              ) : (
                <AdminReportsTable
                  reports={filteredReports}
                  onStatusChange={handleStatusChange}
                />
              )}
            </div>
          );
        
      
      case 'requests':
        return <AdminLeaveRequests />;
      
      case 'qr':
        return <AdminQRManagement />;
      
      case 'presence':
        return <AdminReports />;
      
      // ✅ NUOVO: Tab Verifica Personale
      case 'verifica':
        return <HRVerificaPersonale />;
      
      default:
        return <AdminWorkHours />;
    }
  };

  // ==============================
  // RENDER PRINCIPALE
  // ==============================
  return (
    <div className="admin-panel hr-panel">
      {/* Header centrale con tema verde HR */}
      <div className="hr-main-panel">
        <h2>Pannello HR</h2>
        <p>Gestione completa del personale aziendale</p>
      </div>

      {/* Tab navigation con colore verde */}
      <div className="admin-tabs hr-tabs">
        <button 
          className={`tab-button ${activeTab === 'hours' ? 'active' : ''}`}
          onClick={() => setActiveTab('hours')}
        >
          <span className="tab-icon">📊</span>
          <span className="tab-label">Gestione Ore</span>
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          <span className="tab-icon">👥</span>
          <span className="tab-label">Utenti e Incarichi</span>
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'reports' ? 'active' : ''}`}
          onClick={() => setActiveTab('reports')}
        >
          <span className="tab-icon">📝</span>
          <span className="tab-label">Segnalazioni</span>
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'requests' ? 'active' : ''}`}
          onClick={() => setActiveTab('requests')}
        >
          <span className="tab-icon">📋</span>
          <span className="tab-label">Permessi</span>
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'qr' ? 'active' : ''}`}
          onClick={() => setActiveTab('qr')}
        >
          <span className="tab-icon">📱</span>
          <span className="tab-label">QR Code</span>
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'presence' ? 'active' : ''}`}
          onClick={() => setActiveTab('presence')}
        >
          <span className="tab-icon">📈</span>
          <span className="tab-label">Report Presenze</span>
        </button>
        
        {/* ✅ NUOVO TAB: Verifica Personale */}
        <button 
          className={`tab-button ${activeTab === 'verifica' ? 'active' : ''}`}
          onClick={() => setActiveTab('verifica')}
          title="Verifica posizione e presenza personale"
        >
          <span className="tab-icon">🎯</span>
          <span className="tab-label">Verifica Personale</span>
        </button>
      </div>

      {/* Contenuto del tab attivo */}
      <div className="admin-content hr-content">
        <div className="content-wrapper">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default HRDashboard;